module.exports = __webpack_public_path__ + "img/aParty_110923_C.41509b24.jpg";